export type UserReview =
  | 'CONFIRMED'
  | 'ACTION_REQUIRED'
  | 'IGNORED_INCORRECT'
  | 'IGNORED_IMMATERIAL'
  | 'IGNORED_HANDLED'
  | 'NONE';

export const LEGACY_USER_REVIEW_MAP: Record<string, UserReview> = {
  CHECKED: 'CONFIRMED',
  IGNORED: 'IGNORED_IMMATERIAL',
};
